import { Router } from '@angular/router';

import { Component, ViewChild, ElementRef } from '@angular/core';
import { AbstractComponent } from '../../../../../core/common/component/AbstractComponent';

import { AuthService } from 'src/app/common/service/AuthService';
import moment from 'moment';
import { Title } from '@angular/platform-browser';
import { ToastrService } from 'ngx-toastr';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatDialog } from '@angular/material/dialog';

import { StreamIndexService } from './StreamIndexService';
import { MatSort } from '@angular/material/sort';

@Component({
  selector: 'app-stream',
  templateUrl: './StreamIndex.html',
  styleUrls: ['./StreamIndex.scss']
})
export class StreamIndexComponent extends AbstractComponent {

  public scope = {
    wait : true,
    dataSource: null,
    displayedColumns :[ 
      'streamName', 'streamId','description', 
      'status', 'mediaType', 'dataRetentionInHours', 'aiCheck','dispOrder',
      'actions'
    ]
  }

  @ViewChild(MatPaginator,  { static: true })
  public paginator: MatPaginator;

  @ViewChild(MatSort, {static: true})
  public sort: MatSort;

  public constructor(
    private title: Title,
    private service : StreamIndexService) {
    super();
    this.title.setTitle("Stream Manager");
    
  }
  /**  */
  public componentWillMount() {
  }


  /** 表示 */
  public render() {
    this.service.get().subscribe((streams:any) => {
      this.scope.dataSource = new MatTableDataSource<any>(streams);
      this.scope.dataSource.paginator = this.paginator;
      this.scope.dataSource.sort= this.sort;
      this.scope.wait = false;
    });
  }

}
